import { render } from "./CourseFormView.vue?vue&type=template&id=a3bc32c2&scoped=true&ts=true"
import script from "./CourseFormView.vue?vue&type=script&lang=ts"
export * from "./CourseFormView.vue?vue&type=script&lang=ts"

import "./CourseFormView.vue?vue&type=style&index=0&id=a3bc32c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3bc32c2"]])

export default __exports__